import React from 'react'

function FormFieldError({ formValidation, fieldName }) {
  const isError =
    formValidation &&
    formValidation[fieldName] &&
    formValidation[fieldName].error

  return (
    <ul
      className="Input-errorList u-marginTop1gu"
      data-analytics={isError ? 'error-validation' : null}
    >
      <li
        className={
          'Input-errorListItem u-textSizeMsrm1' +
          (isError ? ' warningIcon' : '')
        }
      >
        {isError ? <>{formValidation[fieldName].errorMessage}</> : <>&nbsp;</>}
      </li>
    </ul>
  )
}

export default FormFieldError
